import { DropResult } from "@hello-pangea/dnd";
import { useCallback, useRef, MutableRefObject } from "react";

import { usePlaceholderContainer } from "@/components/Playground/Messages/PlaceholderContainer/context/placeholder-container-context";

interface ChildDragAndDropConfig {
  dragDisabled: boolean;
  handleDragEnd: (result: DropResult) => void;
  droppableRef: MutableRefObject<HTMLDivElement | null>;
  droppableId: string;
}

export const useChildMessageDragAndDrop = (): ChildDragAndDropConfig => {
  const { readonly, childStore, message } = usePlaceholderContainer();
  const droppableRef = useRef<HTMLDivElement | null>(null);

  const dragDisabled = readonly;
  const droppableId = `placeholder-${message.id}-children`;

  const handleDragEnd = useCallback(
    (result: DropResult) => {
      if (!result.destination || dragDisabled) {
        return;
      }

      const { source, destination } = result;

      if (source.index !== destination.index) {
        childStore.reorderMessages(source.index, destination.index);
      }
    },
    [dragDisabled, childStore],
  );

  return {
    dragDisabled,
    handleDragEnd,
    droppableRef,
    droppableId,
  };
};
